/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaginationDto
 */
export interface PaginationDto {
    /**
     * 
     * @type {number}
     * @memberof PaginationDto
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationDto
     */
    pageSize: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationDto
     */
    total: number;
}

/**
 * Check if a given object implements the PaginationDto interface.
 */
export function instanceOfPaginationDto(value: object): value is PaginationDto {
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('pageSize' in value) || value['pageSize'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function PaginationDtoFromJSON(json: any): PaginationDto {
    return PaginationDtoFromJSONTyped(json, false);
}

export function PaginationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'page': json['page'],
        'pageSize': json['pageSize'],
        'total': json['total'],
    };
}

export function PaginationDtoToJSON(json: any): PaginationDto {
    return PaginationDtoToJSONTyped(json, false);
}

export function PaginationDtoToJSONTyped(value?: PaginationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'page': value['page'],
        'pageSize': value['pageSize'],
        'total': value['total'],
    };
}

